import { Component, OnInit } from '@angular/core';
import { FeedbackService } from 'src/app/vacancies-category/feedback.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent implements OnInit {
  constructor(private feedbackService: FeedbackService) {}

  currentYear: number;
  showPopup: boolean = false;

  onFeedbackClick() {
    this.showPopup = true;
  }

  onComplaintsClick() {
    this.showPopup = true;
  }

  ngOnInit(): void {
    this.checkFeedbackEnabled();
    this.onFeedbackClick();
    this.onComplaintsClick();
    this.currentYear = new Date().getFullYear();
  }

  feedbackActive: boolean = true;
  complaintActive: boolean = true;
  activeVoice: any;
  detailState: string = 'DATA';

  /* Feedback logic */
  checkFeedbackEnabled() {
    this.feedbackService.getSystem().subscribe(
      (response: any) => {
        if (response) {
          console.log('Feedback System response', response);
          this.feedbackActive = response.isFeedbackActive;
        }
      },
      (error: any) => {},
      () => {}
    );
  }
}
